import { render, staticRenderFns } from "./ModalAllTask.vue?vue&type=template&id=1da739e2&lang=pug&"
import script from "./ModalAllTask.vue?vue&type=script&lang=js&"
export * from "./ModalAllTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports